import SEO from '../components/SEO';
import { Truck, RefreshCw, Clock, Globe } from 'lucide-react';

const shippingInfo = [
  { icon: Truck, title: 'UK Standard Delivery', time: '2–4 Business Days', cost: 'Free over £30 | £2.99 under £30', desc: 'All UK orders dispatched within 1 business day. Royal Mail tracked delivery.' },
  { icon: Clock, title: 'UK Express Delivery', time: '1–2 Business Days', cost: '£4.99', desc: 'Order before 1pm for same-day dispatch. Available to most UK mainland addresses. Royal Mail tracked express delivery.' },
  { icon: Globe, title: 'International Shipping', time: '7–12 Business Days', cost: 'From £9.99', desc: 'We ship to selected international destinations. Duties and taxes may apply depending on destination.' },
  { icon: RefreshCw, title: 'Returns Policy', time: '30-Day Money-Back Guarantee', cost: '', desc: 'We stand behind RELOAD. If you\'re not satisfied with your purchase, contact us within 30 days of receiving your order and we\'ll be happy to help.' },
];

export default function Shipping() {
  return (
    <main data-testid="shipping-page" style={{ backgroundColor: '#F7F7F5', minHeight: '100vh', padding: '80px 0' }}>
      <SEO title="Shipping & Returns | UK Delivery" description="RELOAD UK delivery information. Standard 2–4 day delivery, express options, and 30-day money-back guarantee on all orders." canonical="/shipping" />
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <span className="overline block mb-4">Delivery</span>
          <h1 style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 800, fontSize: 'clamp(2rem, 4vw, 3rem)', color: '#0D1A2E', letterSpacing: '-0.025em', marginBottom: '14px' }}>Shipping & Returns</h1>
          <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '1rem', color: '#64748B', lineHeight: 1.75, maxWidth: '520px', margin: '0 auto' }}>
            We aim to get RELOAD to you as quickly as possible.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-14">
          {shippingInfo.map(({ icon: Icon, title, time, cost, desc }) => (
            <div key={title} data-testid={`shipping-card-${title.toLowerCase().replace(/\s+/g, '-')}`} className="card-light card-hover rounded-2xl p-7">
              <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                <div className="icon-bg-blue">
                  <Icon size={20} style={{ color: '#1B3D7E' }} strokeWidth={1.5} />
                </div>
                <div>
                  <h3 style={{ fontFamily: 'Outfit, sans-serif', fontSize: '1.05rem', fontWeight: 700, color: '#0D1A2E', marginBottom: '6px' }}>{title}</h3>
                  <div className="flex flex-wrap gap-3 mb-2">
                    <span style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.75rem', color: '#1B3D7E', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em' }}>{time}</span>
                    {cost && <span style={{ color: '#E2E8F0', fontSize: '0.75rem' }}>|</span>}
                    {cost && <span style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.75rem', color: '#64748B', fontWeight: 600 }}>{cost}</span>}
                  </div>
                  <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.85rem', color: '#64748B', lineHeight: 1.75 }}>{desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-2xl mx-auto" style={{ backgroundColor: '#FFFFFF', borderRadius: '16px', border: '1px solid #E2E8F0', padding: '40px' }}>
          <h2 style={{ fontFamily: 'Outfit, sans-serif', fontSize: '1.4rem', fontWeight: 800, color: '#0D1A2E', marginBottom: '24px', letterSpacing: '-0.02em' }}>Shipping FAQs</h2>
          {[
            { q: 'When will my order be dispatched?', a: 'Orders placed before 1pm (Mon–Fri) are dispatched the same business day. Orders placed after 1pm or on weekends are dispatched the next business day.' },
            { q: 'How do I track my order?', a: 'You will receive a tracking number via email once your order has been dispatched. You can use this to track your delivery through the Royal Mail or courier website.' },
            { q: 'What if my order arrives damaged?', a: 'If your order arrives damaged, please contact us within 48 hours with photos of the damage and we will arrange a replacement or full refund immediately.' },
          ].map(({ q, a }, i) => (
            <div key={q} style={{ borderBottom: i < 2 ? '1px solid #E2E8F0' : 'none', padding: '18px 0' }}>
              <h3 style={{ fontFamily: 'Outfit, sans-serif', fontSize: '0.95rem', fontWeight: 700, color: '#0D1A2E', marginBottom: '8px' }}>{q}</h3>
              <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.87rem', color: '#64748B', lineHeight: 1.8 }}>{a}</p>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
